var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFavorite = function SvgSysFavorite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 2.26 6.662 4.97a1.5 1.5 0 0 1-1.13.821l-2.991.435 2.165 2.11a1.5 1.5 0 0 1 .431 1.328l-.511 2.98 2.676-1.407a1.5 1.5 0 0 1 1.396 0l2.676 1.407-.51-2.98a1.5 1.5 0 0 1 .43-1.327l2.166-2.11-2.992-.436a1.5 1.5 0 0 1-1.13-.82L8 2.26ZM8.448.909a.5.5 0 0 0-.896 0l-1.787 3.62a.5.5 0 0 1-.376.273l-3.995.58a.5.5 0 0 0-.277.853l2.89 2.818a.5.5 0 0 1 .144.442l-.682 3.979a.5.5 0 0 0 .726.527l3.572-1.879a.5.5 0 0 1 .466 0l3.573 1.879a.5.5 0 0 0 .725-.527l-.682-3.979a.5.5 0 0 1 .144-.442l2.89-2.818a.5.5 0 0 0-.277-.853l-3.995-.58a.5.5 0 0 1-.376-.274L8.448.908Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysFavorite;